import { Logout } from '@mui/icons-material';
import { Container, Stack } from '@mui/material';
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';
import { EmptyState, missingPermissions } from 'components/common/empty-state';
import { TooltipIconButton } from 'components/common/icon/tooltip-icon-button';
import { RefreshOrLoading } from 'components/common/loading/refresh-or-loading';
import { FC, useState } from 'react';
import { deleteLocalStorageAuth } from 'utils/local-storage';

export const Unauthorized: FC = () => {
  const [showProgress, setShowProgress] = useState(false);

  const handleLogout = async () => {
    try {
      deleteLocalStorageAuth();
      await signOut();
    } catch (e) {
      console.log('error logging out', e);
    }
  };

  const refresh = async () => {
    try {
      setShowProgress(true);
      const currentUser = await getCurrentUser();
      if (currentUser) {
        await fetchAuthSession({ forceRefresh: true });
        setShowProgress(false);
      }
    } catch (err) {
      console.error('Error refreshing session', err);
      setShowProgress(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        p: {
          xs: 2,
          md: 3,
        },
      }}
    >
      <EmptyState>
        <EmptyState.Image src={missingPermissions} alt="Unauthorized" />
        <EmptyState.PrimaryText>No Permissions Assigned</EmptyState.PrimaryText>
        <EmptyState.SecondaryText>
          Looks like you don&apos;t have any permissions associated with your account. Talk to your
          IT team to grant you access.
        </EmptyState.SecondaryText>
        <Stack direction="row">
          <RefreshOrLoading
            onClick={refresh}
            refreshing={showProgress}
            tooltip="Refresh permissions"
          />
          <TooltipIconButton tooltip="Logout" onClick={handleLogout}>
            <Logout />
          </TooltipIconButton>
        </Stack>
      </EmptyState>
    </Container>
  );
};
